
import Vue from 'vue'
import { Component, Mixins } from 'vue-property-decorator';
import EventBus from './../../eventBus';
import UserProVisioning from "@/mixins/userProvisioning"
import UsersImport from "@/components/UserImport.vue"


interface User {
  firstName: string
  lastName: string
  userName: string
  email: string
  jobTitle: string
  photo: string
  departmentId: string
  operationUnitId: string
  isLocked: boolean
  operationUnitName: string
  isFirstLogin: boolean
  access: Access[]
  permissions: any[]
  roles: string[]
  id: string
  link: string
}

interface Access {
  category: string
  type: string
  id: any
  link: any
}


@Component({
    components:{
    "users-import": UsersImport
    }
})
export default class UsersOverview extends Mixins(UserProVisioning){
    //Data
    search: string = ''
    activeScreen: string = 'loading'
    loadingMessage: string = 'Loading Users'
    loadingTitle: string = 'Loading...'
    notificationButtonState: string = "Show Notification Settings"
    successMessage:string = ''
    additionalSuccessMessage = ''
    showUserImportModal=false

    accessTypes: Array<object> =[
        {value: 'Full', text: "Full"},
        { value: 'ReadOnly', text: "ReadOnly"}
    ]

    selectedUser: any = {
        id:null,
        firstName: '',
        lastName: '',
        position: '',
        departments: ''
    }
    departmentFilter: number = -1
    items: Array<any> = []
    notificationSettings: Array<any> = []
    departments: any
    deletePromptProperty: boolean = false
    error: string  = ''
    loader: boolean = true
    selectedRows: {id: string; email: string; firstName: string; lastName: string}[] = []
    selectAll: boolean = false



    // Methods
    gotoEdit (id: number) {
        let path : object = { path: '/manage-user', query:{id:id}  }
        this.$router.push(path)
    }

    downloadTemplate() {
        this.$store.dispatch('usersModule/downloadUsersTemplateAction');
    }

    getDepartments() {
        return this.$store.dispatch('departmentModule/getDepartments')
    }

    deleteUser(payload: string[]) {
        return this.$store.dispatch('usersModule/deleteUser', payload)
    }

    selectUser(selected: any){
        this.selectedUser.name = selected.name;
        this.selectedUser.position = selected.position;
        this.selectedUser.department = selected.department;
    }

    deleteUserPrompt(selected: any){
        this.selectedUser.id = selected.id
        this.selectedUser.firstName = selected.firstName;
        this.selectedUser.lastName = selected.lastName;
        this.selectedUser.position = selected.position;
        this.selectedUser.department = selected.department;

        this.deletePromptProperty = true
    }

    getUsersToDelete () {
        const fullNames = this.selectedRows.map(row => `${row.firstName} ${row.lastName}`);

        if (fullNames.length <= 3) {
            const lastTwoNames = this.selectedRows.map(row => `${row.firstName} ${row.lastName}`).splice(-2);
            return `${fullNames.length === 3 ? `${fullNames[0]},` : ''} ${lastTwoNames.join(' and ')}`
        }
        else {
            const firstTwoNames = fullNames.slice(0, 2);
            const remainingCount = fullNames.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} user${remainingCount > 1 ? 's' : ''}`;
        }
    }

    doDelete (_bvEvt: any) {
        const isMultipleDelete = this.selectedRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingTitle = 'Deleting User'
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these users' : 'this user'}`
        const payload = isMultipleDelete ? this.selectedRows.map(row => row.id) : [this.selectedUser.id]
        const deletedUsers = isMultipleDelete ? this.getUsersToDelete() : '';
        this.deleteUser(payload).then(() => {
            this.activeScreen="successNoBack"
            EventBus.$emit('activeScreen', this.activeScreen)
            this.successMessage = isMultipleDelete ? `${deletedUsers} Deleted Successfully` 
                : `${this.selectedUser.firstName} ${this.selectedUser.lastName} Deleted Successfully`
            // this.additionalSuccessMessage = 'This User will no longer be available'
            this.additionalSuccessMessage = `${isMultipleDelete ? 'These Users': 'This User'} will no longer be available.`

            this.deletePromptProperty = false
            this.selectedRows = []
        }, (error: any) => {
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.message
            this.deletePromptProperty = false
        })
    }

    toggleSelectAll() {
        if (!this.selectAll) {
            this.selectedRows = this.fillteredUsers(this.search, this.departmentFilter).map((user: User) => ({id: user.id, email: user.email, firstName: user.firstName, lastName: user.lastName}))
        } else {
            this.selectedRows = []
        }
    }

    searchValue(e: any){
        this.search = e
    }

    isSuscribedToNotification(userID: any, notificationType: any){
        if(this.notificationSettings[userID]!=undefined){
            return this.notificationSettings[userID].filter((notSet: any) => notSet.notificationType == notificationType).length?{userId:userID,permissionVal:notificationType}:false
        }else{
            return false
        }
    }

    manageNotificationSettings(){
        if(this.notificationButtonState=="Show Notification Settings"){
            this.fields.push(
                {key: 'not1', label: "Timeline change"},
                {key: 'not2', label: "Budget"},
                {key: 'not3', label: "Well Creation"}
            )
            this.notificationButtonState="Hide Notification Settings"
            return
        }

        if(this.notificationButtonState=="Hide Notification Settings"){
            this.fields.splice((this.fields.length-3),3)
            this.notificationButtonState="Show Notification Settings"
            return
        }

        if(this.notificationButtonState=="Save Notification Settings"){
            var settingsToReturn = []
            for(var userId in this.notificationSettings) {
                settingsToReturn.push({userId,suscriptions:this.notificationSettings[userId]})
            }
            this.activeScreen = 'loading'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.manageSuscription(settingsToReturn).then((res: any)=>{
                this.getNotificationSettings()
                this.activeScreen = 'loading'
                EventBus.$emit('activeScreen', this.activeScreen)
            }).catch((err: any) => {
                this.error = err.message
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
            })
        }
    }

    getNotificationSettings(){
        this.fillteredUsers(this.search,this.departmentFilter).forEach((user: any) => {            
            user.suscribedNotifcations.forEach( (thisSuscribedNotification: any) => {                
                if( this.notificationSettings[user.id] == undefined ){                    
                    this.notificationSettings[user.id] = [{notificationType:thisSuscribedNotification,isSuscribed:true}]
                }else{                    
                    this.notificationSettings[user.id].push({notificationType:thisSuscribedNotification,isSuscribed:true})
                }
            })
        });
    }

    permValueChanged(data: any){
        if(this.notificationSettings[data.userId]!=undefined){            
            var notificationSettingToChange = this.notificationSettings[data.userId].find((thisNotificationSetting: any) => thisNotificationSetting.notificationType==data.permissionVal)
            if(notificationSettingToChange!=undefined){                
                notificationSettingToChange.isSuscribed = !notificationSettingToChange.isSuscribed
            }else{                
                this.notificationSettings[data.userId].push({notificationType:data.permissionVal,isSuscribed:true})
            }
        }else{            
            this.notificationSettings[data.userId] = [{notificationType:data.permissionVal,isSuscribed:true}]
        }
        if(this.notificationButtonState=="Hide Notification Settings")this.notificationButtonState = "Save Notification Settings"
    }


    // Computed propertied
    get getDepartmentOptions () {
        return this.$store.getters['departmentModule/getDepartmentOptions']
    }

    get fillteredUsers () {
        return this.$store.getters['usersModule/fillteredUsers']
    }

    get manageSuscription () {
        return this.$store.getters['usersModule/manageSuscription']
    }

    get fields (){
       
    if(this.canCreateAdmin || this.canCreateUser){
        return  [
            {key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }, },
            { key: 'serial', label: 'S/N', sortable: false },
            {key:'photo', label:"Image"},
            {key: 'firstName', sortable: 'true'},
            {key: 'lastName', sortable: 'true'},
            'jobTitle','email',
            {key: 'button', label: "Actions"} ];
    }
       return  [
            {key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }, },
            { key: 'serial', label: 'S/N', sortable: false },
            {key:'photo', label:"Image"},
            {key: 'firstName', sortable: 'true'},
            {key: 'lastName', sortable: 'true'},
            'jobTitle','email', ];
    
    }

    created() {
        if (this.fillteredUsers('', this.departmentFilter).length === 0){
            this.$store.dispatch('usersModule/getUsers').then((res: any) => {
                this.activeScreen = 'main'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.loader = false
            })
        } else {
            this.activeScreen = 'main'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.loader = false
        }

        if(this.getDepartmentOptions.length===0){
            this.getDepartments()
        }
    }
    
}
